import type { Language } from "@/Common/Models/Domain/Language";
import type {
  AreaApi,
  RegisterTokenApi,
  VerifyEmailApiQuery,
  VerifyApiResponse,
  ResendEmailApiResponse,
  ConfigApi,
  RegisterUserApiQuery,
  ConfigApiQuery,
  GoToPoolApiQuery,
  UpdateRegistrationApiQuery,
  AreaApiQuery,
} from "@/Modules/Models/Api/OnBoarding";
import type { Source } from "@/Common/Models/Domain/Source";

import TherapySideApiService from "./utils/TherapyApi";

class OnBoardingAPIConnector {
  constructor(private readonly ApiService: TherapySideApiService = new TherapySideApiService()) {}

  getConfig(language: Language, source: Source): Promise<ConfigApi> {
    return this.ApiService.get<ConfigApiQuery, ConfigApi>({
      endpoint: "/v1.0/config",
      params: {
        language: language,
        source: source,
      },
    });
  }

  getAreas(language: Language, source: Source): Promise<AreaApi[]> {
    return this.ApiService.get<AreaApiQuery, AreaApi[]>({
      endpoint: "/v1.0/patient_areas",
      params: {
        language: language,
        source: source,
      },
    });
  }

  registerUser(userApiQuery: RegisterUserApiQuery): Promise<RegisterTokenApi> {
    return this.ApiService.post<RegisterUserApiQuery, RegisterTokenApi>({
      endpoint: "/v1.0/users/registration",
      body: userApiQuery,
      responseParams: { raw: true },
    });
  }

  updateRegistrationUser(
    updateRegistrationApiQuery: UpdateRegistrationApiQuery,
    uuid: string
  ): Promise<void> {
    return this.ApiService.patch<UpdateRegistrationApiQuery, void>({
      endpoint: "/v1.0/users/update_comeback/" + uuid,
      body: updateRegistrationApiQuery,
    });
  }

  goToPool(goToPoolApiQuery: GoToPoolApiQuery): Promise<void> {
    return this.ApiService.post<GoToPoolApiQuery, void>({
      endpoint: "/v1.0/users/go_to_pool",
      body: goToPoolApiQuery,
    });
  }

  sendCode(verifyEmailApiQuery: VerifyEmailApiQuery): Promise<VerifyApiResponse> {
    return this.ApiService.post<VerifyEmailApiQuery, VerifyApiResponse>({
      endpoint: "/v1.0/users/verify_email",
      body: verifyEmailApiQuery,
    });
  }

  resendEmail(): Promise<ResendEmailApiResponse | undefined> {
    return this.ApiService.post<void, ResendEmailApiResponse>({
      endpoint: "/v1.0/users/resend_verify_email",
    });
  }
}

export default OnBoardingAPIConnector;
